import { useStaticQuery, graphql } from 'gatsby'

export const useAwardsQuery = () => {
const { wpPage } = useStaticQuery(
    graphql`
  query AwardsQuery{
    wpPage(slug: {eq: "home"}) {
      home {
        awardsTitleLineOne
        awardsTitleRedText
        awardsTitleLineThree
        awardsSubtitle
        awardsParagraph
        awardsImages {
          awardsImagesImage {
            localFile {
              childImageSharp {
                gatsbyImageData(formats: [AUTO, WEBP, AVIF])
              }
            }
          }
          awardsImagesImageAltText
          awardsImagesClass
        }
      }
    }
  }
  `
);
return wpPage.home;
}